import { Divider, makeStyles } from '@fluentui/react-components';
import React from 'react';
import { customPalette } from '../../theme';

export interface IDefaultSeparatorProps {
    height?: string;
}

const useStyles = makeStyles({
    root: {
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // Match prior Fluent 8 Separator light-gray rule (longhands — Griffel rejects borderColor).
        '::before': {
            borderRightColor: customPalette.neutralLightGrey,
        },
        '::after': {
            borderRightColor: customPalette.neutralLightGrey,
        },
    },
});

/**
 * Vertical separator for toolbars/tables. Fluent 9 Divider; height prop kept for callers.
 */
const DefaultSeparator: React.FC<IDefaultSeparatorProps> = ({ height }) => {
    const styles = useStyles();

    return <Divider vertical className={styles.root} style={{ height: height ?? '32px' }} />;
};

export default DefaultSeparator;
